import { render, staticRenderFns } from "./HasReadMailConditionDescription.vue?vue&type=template&id=4df4d980&"
import script from "./HasReadMailConditionDescription.vue?vue&type=script&lang=js&"
export * from "./HasReadMailConditionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports